import React from 'react';
import Card from '../../common/components/Card/Card.jsx';
import CardHeader from '../../common/components/Card/CardHeader.jsx';
import CardBody from '../../common/components/Card/CardBody.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import '../../../assets/css/material-dashboard-react.css';

const styles = theme => ({
  cardHeader: {
    padding: '15px',
    marginTop: '-20px',
    borderRadius: '3px',
    background: '#465337',
    boxShadow:
      '0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)',
    color: '#FFF',
    margin: '0 15px',
    position: 'relative',
    zIndex: '3 !important',
    borderBottom: 'none',
    display: 'flex'
  },
  titleSection: {
    height: '20px',
    float: 'left',
    flex: 8
  },
  buttonContainer: {
    display: 'flex',
    flex: 1
  },
  cardTitle: {
    marginTop: '0px',
    minHeight: 'auto',
    marginBottom: '3px',
    textDecoration: 'none'
  },
  cardTitleWhite: {
    color: 'white',
    margin: '0',
    lineHeight: '1',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: 'gray',
      fontWeight: '400',
      lineHeight: '1'
    }
  },
  cardCategory: {
    color: '#edaaa5',
    margin: 0,
    marginTop: 0,
    marginBottom: 0
  },
  card: {
    maxWidth: 400
  },
  cardBody: {
    height: 800
  },
  button: {
    backgroundColor: '#6F8753',
    color: 'white',
    margin: '2%',
    flex: 1
  },
  successText: {
    color: 'green'
  },
  upArrowCardCategory: {
    width: '16px',
    height: '16px'
  },
  stats: {
    color: 'gray',
    display: 'inline-flex',
    fontSize: '12px',
    lineHeight: '22px',
    '& svg': {
      top: '4px',
      width: '16px',
      height: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px'
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      top: '4px',
      fontSize: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px'
    }
  },
  cardCategoryWhite: {
    color: 'white',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  axisTitle: {
    fill: 'white',
    fillOpacity: 0.8
  },
  paperWrapper: {
    backgroundColor: '#fafafa',
    [theme.breakpoints.up('md')]: {
      padding: '10px'
    },
    [theme.breakpoints.down('md')]: {
      boxShadow: 'none'
    },
    padding: '10px 0px'
  }
});

const iframeDivStyle = { height: '300px' };

const Financial = props => {
  return (
    <Card>
      <CardHeader className={props.classes.cardHeader}>
        <div className={props.classes.titleSection}>
          <h4 className={props.classes.cardTitleWhite}>
            Financial Health Summary
          </h4>
          <div className="tooltip" style={{ color: '#809c5f' }}>
            Need to sign in?
            <span className="tooltiptext">
              Some panels require signing into Tableau to display information.
              If you need credentials, please contact Bob Ritchie.
            </span>
          </div>
        </div>
        <div className={props.classes.buttonContainer}>
          <Link
            component={RouterLink}
            to="/admin/FinancialDetails"
            style={{ textDecoration: 'none' }}
          >
            <Button className={props.classes.button}>Details</Button>
          </Link>
        </div>
      </CardHeader>
      <CardBody>
        <div className="Financial" style={iframeDivStyle}>
          <iframe
            scrolling="no"
            height="100%"
            width="100%"
            src="https://tableau.usafptn.com/t/Culver/views/HRCFinancialSummary/HRCFinancialSummary?iframeSizedToWindow=true&:embed=y&:display_count=no&:showAppBanner=false&:showVizHome=no&:toolbar=no"
            frameBorder="0"
            allowFullScreen={true}
            title="Financial"
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(Financial);
